export default __webpack_public_path__ + "static/media/headerDapps.d6d69870.svg";